import { render } from "./PathChapterHolder.vue?vue&type=template&id=7d323548&ts=true"
import script from "./PathChapterHolder.vue?vue&type=script&lang=ts"
export * from "./PathChapterHolder.vue?vue&type=script&lang=ts"

import "./PathChapterHolder.vue?vue&type=style&index=0&id=7d323548&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__